import minimalAuth from '@middlewares/MinimalAuth';

export default [
  {
    url: '/offline-trips',
    page: 'offline-trips/Index',
    name: 'offline-trips',
    meta: {
      label: 'Offline Trips',
      layout: 'Dashboard',
      role: {
        only: ['tourist'],
      },
      middleware: [minimalAuth],
    },
    group: [
      {
        url: 'create',
        page: 'offline-trips/Create',
        name: 'new-offline-trip',
        meta: {
          middleware: [minimalAuth],
        },
      },
      {
        url: 'edit',
        page: 'offline-trips/Create',
        name: 'edit-offline-trip',
        meta: {
          middleware: [minimalAuth],
        },
      },
    ],
  },
];
